/**
 * Created by mateimisarca on 18/09/2020
 */

export const CHANGE_LOCALE = 'app/LanguageProvider/CHANGE_LOCALE';
export const DEFAULT_LOCALE = 'en';
